import { render, staticRenderFns } from "./SoftwareLimits.vue?vue&type=template&id=74c9312e&scoped=true&"
import script from "./SoftwareLimits.vue?vue&type=script&lang=js&"
export * from "./SoftwareLimits.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLimits.vue?vue&type=style&index=0&id=74c9312e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c9312e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
